<script>
    // Stores 
    import { 
        textSite,

    } from '../store.js';  

    import { link}   from "svelte-routing";  

	// Componentes
    import PageHeader       from '../components/PageHeader.svelte';
    import FeedTwitter      from '../components/FeedTwitter.svelte'

    // Code
    let titlePage = 'Bolsa de Imóveis e Oportunidades';
</script>

<section class="conteudo-internas">
    <PageHeader title={titlePage} />
    <div class="container">
        <FeedTwitter />
    </div>
</section>